import { gql } from '@apollo/client';

import { PageFields } from '../fragments';

const UPDATE_EMAIL = gql`
  mutation UpdateEmail(
    $email: String!
    $id: String!
    $type: String!
    $subscribeToNewsletter: Boolean!
    $termsAndConditionsAccepted: Boolean!
  ) {
    updateEmail(
      email: $email
      id: $id
      type: $type
      subscribeToNewsletter: $subscribeToNewsletter
      termsAndConditionsAccepted: $termsAndConditionsAccepted
    ) {
      ...PageFields
    }
  }
  ${PageFields}
`;

const SELECT_CURRENCY = gql`
  mutation SelectCurrency(
    $blockchain: String!
    $currency: String!
    $id: String!
    $methodId: String!
    $type: String!
    $paymentMethod: String!
  ) {
    selectCurrency(
      currency: $currency
      id: $id
      type: $type
      blockchain: $blockchain
      methodId: $methodId
      paymentMethod: $paymentMethod
    ) {
      ...PageFields
    }
  }
  ${PageFields}
`;

const UPDATE_COUNTRY = gql`
  mutation UpdateCountry($country: String!, $id: String!, $type: String!) {
    updateCountry(country: $country, id: $id, type: $type) {
      ...PageFields
    }
  }
  ${PageFields}
`;

const REOPEN_PAYMENT = gql`
  mutation ReopenBillPayment(
    $id: String!
    $paymentId: String!
    $type: String!
  ) {
    reopenBillPayment(id: $id, paymentId: $paymentId, type: $type) {
      __typename
      ...PageFields
    }
  }
  ${PageFields}
`;

const STOP_PAYMENT = gql`
  mutation StopPayment($id: String!, $paymentId: String!, $reason: String!) {
    stopPayment(id: $id, paymentId: $paymentId, reason: $reason) {
      __typename
      ...PageFields
    }
  }
  ${PageFields}
`;

const EXPIRE_BILL = gql`
  mutation ExpireBill($id: String!, $reason: String!) {
    expireBill(id: $id, reason: $reason) {
      __typename
      ...PageFields
    }
  }
  ${PageFields}
`;

const SELECT_METHOD = gql`
  mutation SelectMethod($id: String!, $methodId: String!, $type: String!) {
    selectMethod(id: $id, methodId: $methodId, type: $type) {
      __typename
      ...PageFields
    }
  }
  ${PageFields}
`;

const SEND_ANALYTICS = gql`
  mutation AnalyticsProxy(
    $data: Json!
    $eventName: String!
    $id: String!
    $type: String!
  ) {
    analyticsProxy(data: $data, eventName: $eventName, id: $id, type: $type) {
      __typename
      ...PageFields
    }
  }
  ${PageFields}
`;

const RESTART_BILL = gql`
  mutation RestartBill($reason: String!, $id: String!, $type: String!) {
    restartBill(reason: $reason, id: $id, type: $type) {
      ...PageFields
    }
  }
  ${PageFields}
`;

const UPDATE_BUYER_DETAILS = gql`
  mutation UpdateBuyerDetails(
    $city: String!
    $firstName: String!
    $id: String!
    $lastName: String!
    $residentialAddress: String!
    $type: String!
    $residentialCountry: String!
    $taxNumber: String!
  ) {
    updateBuyerDetails(
      city: $city
      firstName: $firstName
      id: $id
      lastName: $lastName
      residentialAddress: $residentialAddress
      type: $type
      residentialCountry: $residentialCountry
      taxNumber: $taxNumber
    ) {
      ...PageFields
    }
  }
  ${PageFields}
`;

export {
  UPDATE_EMAIL,
  UPDATE_COUNTRY,
  SELECT_CURRENCY,
  STOP_PAYMENT,
  REOPEN_PAYMENT,
  EXPIRE_BILL,
  SELECT_METHOD,
  SEND_ANALYTICS,
  RESTART_BILL,
  UPDATE_BUYER_DETAILS,
};
